module.exports = __webpack_public_path__ + "static/media/history-redo.e87c329c.svg";